/**
 * Created by rcabr on 4/15/2016.
 */
angular.module('global.directives', [
    /*Global Directives*/
])

    .directive("ngTouchstart", [function () {
        return {
            controller: ['$scope', '$element', function ($scope, $element) {
                $element.bind('touchstart', onTouchStart);

                function onTouchStart(event) {
                    angular.element('.touch-start').removeClass('touch-start');
                    $element.addClass('touch-start');
                    var method = $element.attr('ng-touchstart');
                    if (!method || method == "") {
                        return;
                    }
                    $scope.$event = event;
                    $scope.$apply(method);
                }
            }]
        };
    }])

    .directive("ngDragenter", [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('dragenter', function (e) {
                    $(element).addClass(attrs.ngDragenter);
                });
            }
        };
    }])
    .directive("ngDragend", [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('dragend dragleave dragexit drop', function (e) {
                    $("." + attrs.ngDragend).removeClass(attrs.ngDragend);
                });
            }
        };
    }])

    .directive('preloadImage', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                preloadImage: '@',
                altText: '@'
            },
            link: function (scope, element, attrs) {
                const directiveName = 'preloadImage';
                attrs.$observe(directiveName, function () {
                    const imageExpression = attrs['preloadImage'];
                    const altText = attrs['altText'];
                    if (imageExpression == null || imageExpression === "") {
                        if (attrs.blurIfNotFound) {
                            angular.element(element).find('.imagePlaceholder').addClass('blurIfNotFound');
                        }
                        return;
                    }
                    if (imageExpression != null) {
                        if (attrs.blurIfNotFound) {
                            angular.element(element).find('.imagePlaceholder').removeClass('blurIfNotFound');
                        }
                        preloadImage(imageExpression, altText, function (url, altText) {
                            if (imageExpression == url) {
                                angular.element(element).find('.accessible__image').attr({
                                    "src": url,
                                    "alt": altText
                                });
                                angular.element(element).find('.preloadImage').css({
                                    "background": "url('" + url + "') center center no-repeat",
                                    "opacity": 1
                                }).attr({
                                    "aria-label": altText
                                });
                                $timeout(function () {
                                    angular.element(element).find('.imagePlaceholder').css('background', 'transparent');
                                }, 0)
                            }
                        })
                    }
                });
                return null;
            },

            template: [
                '<div class="imagePlaceholder">',
                '<img class="accessible__image" style="opacity: 0; display: none;" src="#" alt="#">',
                '<div class="preloadImage"></div>',
                '</div>'
            ].join('')
        }
    }])

    .directive('preloadBgImage', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                preloadImage: '@',
                altText: '@'
            },
            link: function (scope, element, attrs) {
                const directiveName = 'preloadBgImage';
                attrs.$observe(directiveName, function () {
                    const imageExpression = attrs['preloadBgImage'];
                    const altText = attrs['altText'];
                    if (imageExpression == null || imageExpression === "") {
                        if (attrs.blurIfNotFound) {
                            angular.element(element).find('.bgImagePlaceholder').addClass('blurIfNotFound');
                        }
                        return;
                    }
                    if (imageExpression != null) {
                        if (attrs.blurIfNotFound) {
                            angular.element(element).find('.bgImagePlaceholder').removeClass('blurIfNotFound');
                        }
                        preloadImage(imageExpression, altText, function (url, altText) {
                            if (imageExpression === url) {
                                angular.element(element).find('.accessible__image').attr({
                                    "src": url,
                                    "alt": altText
                                });
                                angular.element(element).find('.bgImage').css({
                                    "background": "url('" + url + "') center center no-repeat",
                                    "opacity": 1
                                });
                                $timeout(function () {
                                    angular.element(element).find('.bgImagePlaceholder').css('background', 'transparent');
                                }, 0)
                            }
                        })
                    }
                });
                return null;
            },

            template: [
                '<div class="bgImagePlaceholder">',
                '<img class="accessible__image" style="opacity: 0; display: none;" src="#" alt="#">',
                '<div class="bgImage"></div>',
                '</div>'
            ].join('')
        }
    }])

    .directive('focusIf', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                const dom = $element[0];
                if ($attrs.focusIf) {
                    $scope.$watch($attrs.focusIf, focus);
                } else {
                    focus(true);
                }

                function focus(condition) {
                    if (condition) {
                        $timeout(function () {
                            dom.focus();
                        }, $scope.$eval($attrs.focusDelay) || 0);
                    }
                }
            }
        }
    }])

    .directive('focusIfClick', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                $element.on("click", function () {
                    var id = $attrs.focusIfClick;
                    $("#" + id).blur().focus();
                });
            }
        }
    }])

    .directive('elementValue', [function () {
        return {
            restrict: 'A',
            scope: {
                elementValue: '<'
            },
            link: function ($scope, $element, $attrs) {
                $scope.$watch('elementValue', function () {
                    angular.element($element).text($scope.elementValue);
                });
            }
        }
    }])

    .directive('hrefValue', [function () {
        return {
            restrict: 'A',
            scope: {
                hrefValue: '<'
            },
            link: function ($scope, $element, $attrs) {
                $scope.$watch('hrefValue', function () {
                    angular.element($element).attr('href', $scope.hrefValue);
                });
            }
        }
    }])

    .directive('elementAttr', [function () {
        return {
            restrict: 'A',
            scope: {
                elementAttr: '@',
                elementAttrValue: '<'
            },
            link: function ($scope, $element, $attrs) {
                $scope.$watch('elementAttrValue', function () {
                    angular.element($element).attr($scope.elementAttr, $scope.elementAttrValue);
                });
            }
        }
    }])

    .directive('setClassWhenAtTop', ['$window', '$timeout', 'FilterFactory', function ($window, $timeout, FilterFactory) {
        var $win = angular.element($window); // wrap window object as jQuery object
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                function measureElements() {
                    $timeout(function () {
                        scope.topClass = attrs.setClassWhenAtTop; // get CSS class from directive's attribute value
                        scope.offsetTop = element.offset().top; // get element's top relative to the document
                        scope.navbarHeight = angular.element('#main__navbar').height();
                        safeApply(scope);
                    }, 500);
                }

                measureElements();

                scope.$on('windowResized', function () {
                    measureElements();
                });

                scope.$on('windowScrolled', function () {
                    let promoBarOffset = scope.$root['promoBarIsOpen'] ? 44 : 0;
                    if ($window.innerWidth < 960) return;
                    if ($win.scrollTop() >= (scope.offsetTop - (scope.navbarHeight - promoBarOffset))) {
                        element.css('top', scope.navbarHeight + promoBarOffset + 'px');
                        element.addClass(scope.topClass);
                    } else {
                        element.css('top', 0 + 'px');
                        element.removeClass(scope.topClass);
                    }
                });
            }
        }
    }])

    .directive("outsideClick", ['$document', '$parse', function ($document, $parse) {
        return {
            link: function ($scope, $element, $attributes) {
                var scopeExpression = $attributes.outsideClick;
                // console.log('scopeExpression', scopeExpression);
                onDocumentClick = function (event) {
                    var isChild = $element.find(event.target).length > 0;
                    let isUploadLimitMsgClose = event.target.id ? event.target.id === 'upload__limit__msg__close__1' || event.target.id === 'upload__limit__msg__close' : false;
                    if (isUploadLimitMsgClose) {
                        $scope.$apply("browseCtrl.showAccount = true");
                        return;
                    }
                    if (!isChild) {
                        // console.log('apply', scopeExpression);
                        $scope.$apply(scopeExpression);
                    }
                };

                $document.on("click", onDocumentClick);

                $element.on('$destroy', function () {
                    //console.log('destroy')
                    $document.off("click", onDocumentClick);
                });
            }
        }
    }])

    .directive('infiniteScroll', [
        '$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
            return {
                scope: {
                    infiniteScroll: '&'
                },

                link: function (scope, elem, attrs) {
                    var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
                    $window = angular.element($window);
                    scrollDistance = 0;
                    if (attrs.infiniteScrollDistance != null) {
                        scope.$watch(attrs.infiniteScrollDistance, function (value) {
                            return scrollDistance = parseInt(value, 10);
                        });
                    }
                    scrollEnabled = true;
                    checkWhenEnabled = false;
                    if (attrs.infiniteScrollDisabled != null) {
                        scope.$watch(attrs.infiniteScrollDisabled, function (value) {
                            scrollEnabled = !value;
                            if (scrollEnabled && checkWhenEnabled) {
                                checkWhenEnabled = false;
                                return handler();
                            }
                        });
                    }
                    handler = function (e) {
                        var elementBottom, remaining, shouldScroll, windowBottom;
                        windowBottom = $window.height() + $window.scrollTop();
                        elementBottom = elem.offset().top + elem.height();
                        remaining = elementBottom - windowBottom;
                        shouldScroll = remaining <= $window.height() * scrollDistance;
                        if (shouldScroll && scrollEnabled) {
                            if ($rootScope.$$phase) {
                                return scope.$eval(attrs.infiniteScroll);
                            } else {
                                return scope.$apply(scope.infiniteScroll);
                            }
                        } else if (shouldScroll) {
                            return checkWhenEnabled = true;
                        }
                    };
                    $window.on('scroll', handler);
                    scope.$on('$destroy', function () {
                        return $window.off('scroll', handler);
                    });
                    return $timeout((function () {
                        if (attrs.infiniteScrollImmediateCheck) {
                            if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
                                return handler();
                            }
                        }
                    }), 0);
                }
            };
        }
    ])

    .directive('listenOnClick', ['$timeout', function ($timeout) {
        return function ($scope, $element) {
            $element.bind('click', function () {
                angular.element('#global__s-bar').blur().focus();
            });
        };
    }])

    .directive('bindHtmlCompile', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.bindHtmlCompile);
                }, function (value) {
                    element.html(value && value.toString());
                    var compileScope = scope;
                    if (attrs.bindHtmlScope) {
                        compileScope = scope.$eval(attrs.bindHtmlScope);
                    }
                    $compile(element.contents())(compileScope);
                });
            }
        };
    }])

    .directive('structuredData', ['$filter', function ($filter) {
        return {
            restrict: 'A',
            scope: {
                structuredData: '=',
                structuredDataContent: '=',
            },
            link: function ($scope, $element, $attrs) {
                $scope.$watch('structuredDataContent', function (value) {
                    if(value){
                        const val = $filter('json')(value);
                        $('<script id="customStructuredData" type="application/ld+json">' + val + '</script>').insertAfter($('#genericStructuredData'));
                    }
                });
            }
        };
    }]);



